import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import './Cosection.css';
import questionn from "../assets/images/krinvy_getintouch.png";

const Cosection = ({ setShowQuoteModal }) => {
  return (
    <div className="contactt-container">
      <div>
        <img src={questionn} alt="Get in Touch with Krinvy" className="img-question" />
      </div>
      <div className="contact-content">
        <h2>Let's create something extraordinary together.</h2>
        <p className="ppp-question">Book a free consultation with our experts to discuss your project ideas</p>
        
        <div className="contact-buttons">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="contact-btn get-started-btn"
            onClick={() => setShowQuoteModal(true)}
          >
            <span>Schedule a Call</span>
            <ArrowRightIcon className="w-5 h-5 ml-2" />
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Cosection;